var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v(" Terms and Conditions ")]),_c('v-card-text',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }